import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isEmpty } from 'lodash';
import { Company, Note } from 'src/app/classes/models';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-edit-client-vive-status-modal',
  templateUrl: './edit-client-vive-status-modal.component.html',
  styleUrl: './edit-client-vive-status-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditClientViveStatusModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private ToastService: ToastService
  ) {}

  @Input() status?: Company['status'];
  @Input() Company?: Company;

  currentCompanyStatus?: Company['status'];
  oldCompanyStatus?: Company['status'];

  companyStatuses: string[] = [
    'unactivated',
    'reviewed',
    'activated',
    'deactivated'
  ];

  note: string = '';
  noteTitle: string = '';

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  onCompanyStatusChange() {
    this.currentCompanyStatus = this.status;

    this.updateNoteTitle();
  }

  updateNoteTitle() {
    this.noteTitle = `VIVE STATUS CHANGE ${this.oldCompanyStatus} > ${this.currentCompanyStatus}`;
  }

  save() {
    const note: Note = {
      title: this.noteTitle,
      note: this.note
    };

    if (isEmpty(note.note)) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save note. No note body was entered.',
        { returnError: true }
      );
    }

    if (this.currentCompanyStatus === this.oldCompanyStatus) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save note. No status update was made.',
        { returnError: true }
      );
    }

    if (!this.Company) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot change company status. No company record found.',
        { returnError: true }
      );
    }

    Object.assign(this.Company, { Notes: [note], status: this.status });

    this.activeModal.close();
  }

  ngOnInit(): void {
    if (!this.status) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Company Status.',
        { returnError: true }
      );
    }

    this.currentCompanyStatus = this.status;
    this.oldCompanyStatus = this.status;

    this.updateNoteTitle();
  }
}
